import React, { Component, Fragment } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';
import SimpleTable from "../helper/SimpleTable";
import DeleteDialog from '../helper/Dialogs';
import { authContext } from "../../context/AuthContext";

class WorkshopCategories extends Component {
    static contextType = authContext;

    state = {
        categories: [],
        error: null,
        id: null,
        name: '',
        code: '',
        sortOrder: '',
        isDeleteDialogOpen: false,
        itemToDelete: ''
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/administration/workshopCategory');
    }

    onEdit = (tag) => {
        let id = tag;
        this.props.history.push('/administration/workshopCategory/' + id);
    }

    openDeleteDialog = (tag) => {
        this.setState({ itemToDelete: tag });
        this.handleDeleteDialogOpen();
    }

    onDelete = (event) => {
        // let id = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let id = this.state.itemToDelete;
        this.setState({ itemToDelete: '' });
        let token = sessionStorage.getItem('accessToken');
        var url = "/api/category/" + id;

        axios(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            } 
        })
        .then(response => {
            // console.log("response status: " + response.status);
            // console.log("response message: " + response.statusText);

            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            this.refresh();
        }).catch(err => {
          ///  this.setState({ error: err.message });
            console.log(this.error);
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    refresh() {
        axios.get('/api/category', {
        }).then((res) => {
            // console.log(res);
            this.setState({
                categories: res.data.categories
            });
        }).catch(error => {
            console.log("error:" + error);
            this.setState({
                error: error.message
            });
        });
    }

    componentDidMount() {
        this.refresh();
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    render() {
        const { classes } = this.props;
        const enableActions = this.context.roles.isClassroomTrainingAdmin === 1? true:false;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.categories.length === 0) return <Loading />;

        let enhancedData = [];
        enhancedData = this.state.categories.map((arrayItem) => {
            let item = JSON.parse(JSON.stringify(arrayItem))
            item.actionsDisabled = {
                edit: false,
                delete: false
            }
            return item;
        });

        const tableCells = [
            { id: 'categoryName', label: 'Name', centered: false },
            { id: 'categoryCode', label: 'Code', centered: true },
            { id: 'sortOrder', label: 'Sort Order', centered: true }
        ];

        const actionButtons = [
            { icon: "edit", action: this.onEdit, delete: false },
            { icon: "delete", action: this.openDeleteDialog, delete: true }
        ];

        return (
            <Fragment>
                <PageHeader
                    title={"Workshop Categories"}
                    actionButtons={[{ label: "Add New Category", action: this.onNew, disabled: enableActions === false }]}
                />

                <div>
                    <div className={classes.root}>
                        <div>
                            <br />
                            <SimpleTable
                                data={enhancedData}
                                cellKey={"ID"}
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={enableActions}
                            />
                            <DeleteDialog
                                open={this.state.isDeleteDialogOpen}
                                onClose={this.handleDeleteDialogClose}
                                onDelete={this.onDelete}
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// export default WorkshopCategories;
export default withStyles(styles, { withTheme: true })(WorkshopCategories);
